import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import Stocks from '@/components/modules/ddts/Stocks'
import RevenueChart from '@/components/common/RevenueChart'
import Pricelist from '@/components/modules/products/Pricelist'
import ProductTabs from '@/components/modules/products/ProductTabs'
import PricelistEdit from '@/components/modules/products/PricelistEdit'
import VariantsProduct from '@/components/modules/products/VariantsProduct'
import LotsSettings from '@/components/modules/products/settings/LotsSettings'
import AttributesProduct from '@/components/modules/products/AttributesProduct'
import ComponentsProduct from '@/components/modules/products/ComponentsProduct'
import ProductsSettings from '@/components/modules/products/settings/ProductsSettings'
import MovementsSettings from '@/components/modules/products/settings/MovementsSettings'
import AttributesSettings from '@/components/modules/products/settings/AttributesSettings'
import PricelistsSettings from '@/components/modules/products/settings/PricelistsSettings'
import WarehousesSettings from '@/components/modules/products/settings/WarehousesSettings'

export const products = [
	{
		path: '/attributes',
		redirect: '/products/attributes'
	},
	{
		path: '/pricelists',
		redirect: '/products/pricelists'
	},	
	{ 
		path: '/products', 
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/products/',
					text: 'Prodotti',
				},
				{
					to: '/products/lots/',
					text: 'Lotti',
					model: 'lot'
				},
				{
					to: '/products/attributes/',
					text: 'Attributi',
					model: 'attribute'
				},
				{
					to: '/products/pricelists/',
					text: 'Listini Anagrafici',
					model: 'pricelist'
				},
				{
					to: '/products/movements/',
					text: 'Movimenti',
					model: 'movement'
				},
				{
					to: '/products/warehouses',
					text: 'Magazzini',
					model: 'warehouse'
				},
				{
					to: '/products/stocks',
					text: 'Giacenze',
					model: 'stock'
				},
			],
		},
		children: [
			{
				path: '/products/',
				name: 'products-index',
				meta: {
					title: trans('products')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'products',
					actionIcon: 'local_offer',
					title: 'Prodotti',
					styleClass: 'mb-offset'
				}
			},		
			{
				path: '/products/lots/',
				name: 'lots-index',
				meta: {
					title: trans('lots')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'lots',
					actionIcon: 'mdi-package-variant-closed',
					title: 'Lotti Prodotti',
					styleClass: 'mb-offset',
				}
			},
			{
				path: '/products/attributes/',
				name: 'attributes-index',
				meta: {
					title: trans('attributes')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'attributes',
					actionIcon: 'local_offer',
					title: 'Attributi Prodotti',
					styleClass: 'mb-offset',
					crudDialog: true,
				}
			},		
			{
				path: '/products/pricelists/',
				name: 'pricelists-index',
				meta: {
					title: trans('pricelists')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'pricelists',
					actionIcon: 'local_offer',
					title: 'Listini Anagrafici',
					styleClass: 'mb-offset'
				}
			},		
			{
				path: '/products/movements/',
				name: 'movements-index',
				meta: {
					title: trans('movements')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'movements',
					actionIcon: 'local_offer',
					title: 'Movimenti',
					speedDialOptions: {
						add: false,
						delete: false
					},
				}
			},	
			{
				path: '/products/warehouses',
				name: 'warehouses-index',
				meta: {
					title: trans('warehouses')
				},
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: {
					modelDef: 'warehouses',
					actionIcon: 'store',
					title: 'Magazzini',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/products/stocks',
				name: 'stocks-index',
				meta: {
					title: trans('stocks')
				},
				beforeEnter: ifAuthenticatedOnline,
				component: Stocks,
			},
		],
	},
	{ 
		path: '/products/create',
		name: 'products-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'products',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/products/:id/edit',
		name: 'products-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'products',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/products/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: ProductTabs,
		props: (route) => ({
			id: parseInt(route.params.id)
		}), 
		children: [
			{
				path: '',
				name: 'products-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'products',
					modelClass: 'product',
					activities: true,
					maillogs: false,
					fileuploader: true,
					photoAssignment: true,
				}),
			},
			{
				path: 'lots',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: trans('lots'),
				},
				props: (route) => ({
					title: 'Lotti',
					modelDef: 'lots',
					actionIcon: 'mdi-package-variant-closed',
					styleClass: 'mb-offset',
					subFilters: {products: parseInt(route.params.id)},
					defaultInput: {product_id: parseInt(route.params.id)},
				}),
			},
			{
				path: 'serials',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: trans('serials'),
				},
				props: (route) => ({
					title: 'Matricole',
					modelDef: 'lots',
					routeModel: 'serials',
					actionIcon: 'mdi-package-variant-closed',
					styleClass: 'mb-offset',
					subFilters: {products: parseInt(route.params.id)},
					defaultInput: {product_id: parseInt(route.params.id), type: 'serial'},
				}),
			},
			{
				path: 'units',
				beforeEnter: ifAuthenticated,
				component: Crud,
				meta: {
					title: 'Unità di misura',
				},
				props: (route) => ({
					title: 'Unità di misura',
					modelDef: 'productunits',
					actionIcon: 'mdi-scale-balance',
					styleClass: 'mb-offset',
					subFilters: {products: parseInt(route.params.id)},
					defaultInput: {product_id: parseInt(route.params.id)},
					crudDialog: true,
				}),
			},
			{
				path: 'attributes',
				component: AttributesProduct, 
				props: (route) => ({
					id:  parseInt(route.params.id)
				}),
			},
			{
				path: 'variants',
				beforeEnter: ifAuthenticatedOnline,
				component: VariantsProduct, 
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
			{
				path: 'components',
				beforeEnter: ifAuthenticatedOnline,
				component: ComponentsProduct, 
				props: (route) => ({
					id: parseInt(route.params.id)
				}),
			},
			{
				path: 'analytics',
				beforeEnter: ifAuthenticatedOnline,
				component: RevenueChart, 
				props: (route) => ({
					modelId: parseInt(route.params.id),
					modelKey: 'product_id',
					url: 'productsrevenuestats',
					title: 'Costi e Ricavi',
					balloonText: '[[title]] di [[category]]: <b>[[value]] €</b>'
				}),
			},
			{
				path: 'movements',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud, 
				props: (route) => ({
					modelDef: 'movements',
					actionIcon: 'local_offer',
					title: 'Movimenti',
					subFilters: {products: parseInt(route.params.id)},
					speedDialOptions: {'add': false, 'delete': false},
					actionPosition: 'fixed'
				}),
			},
		]
	},
	{ 
		path: '/products/lots/:id/edit',
		name: 'lots-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'lots',
			id:  parseInt(route.params.id),
		}),
	},
	{
		path: '/products/lots/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/products/lots/' + parseInt(route.params.id) + '/',
					text: 'Lotto',
				},
				{
					to: '/products/lots/' + parseInt(route.params.id) + '/movements',
					text: 'Movimenti',
					model: 'movement'
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'lots-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'lots',
					modelClass: 'lot',
					comments: true,
					maillogs: false,
					fileuploader: true,
				}),
			},
			{
				path: 'movements',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: (route) => ({
					modelDef: 'movements',
					actionIcon: 'local_offer',
					title: 'Movimenti',
					subFilters: {lots: parseInt(route.params.id)},
					speedDialOptions: {'add': false, 'delete': false},
					actionPosition: 'fixed'
				}),
			},
		]
	},
	{
		path: '/products/lots/create',
		name: 'lots-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'lots',
			redirect: route.params.redirect,
			defaultInput: route?.params?.defaultInput,
		}),
	},
	{
		// Rotta gemella di lots-create per il bottone "+" della lista matricole
		// (Crud.vue instrada su routeModel + '-create', vedi openCreate()). Stesso
		// componente/modelDef 'lots': type='serial' arriva sia come defaultInput
		// (compilazione form, girato dalla lista) sia come query string sulla GET
		// lots/create (LotsAPIController::create legge request()->type per
		// etichettare il pannello "Nuova Matricola" invece di "Nuovo Lotto").
		// redirect fisso su serials-show: senza, Create.vue cadrebbe sul default
		// modelDef + '-show' = lots-show (vedi qa-utente-9-fix-report.md).
		path: '/products/serials/create',
		name: 'serials-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'lots',
			queryParams: 'type=serial',
			redirect: route.params.redirect || {modelDef: 'serials-show'},
			defaultInput: route?.params?.defaultInput,
		}),
	},
	{
		path: '/products/serials/:id/edit',
		name: 'serials-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'lots',
			id:  parseInt(route.params.id),
			// Edit.vue interpreta redirect.modelDef come nome di rotta completo
			// (chooseRedirect in eventBusUtility.js), a differenza di Show.vue che
			// vi appende '-edit': qui serve il nome della show, non lo slug nudo.
			redirect: {modelDef: 'serials-show', id: parseInt(route.params.id)},
		}),
	},
	{
		// Rotta gemella di /products/lots/:id/: stessi componenti (il record
		// resta un Lot, modelDef 'lots'), ma nome e breadcrumb dedicati alla
		// matricola. Serve perche' il Crud della lista /products/:id/serials
		// naviga per nome di rotta (routeModel: 'serials') e /products/lots/:id
		// non esiste per lei — vedi qa-utente-4-fix-report.md.
		path: '/products/serials/:id/',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/products/serials/' + parseInt(route.params.id) + '/',
					text: 'Matricola',
				},
				{
					to: '/products/serials/' + parseInt(route.params.id) + '/movements',
					text: 'Movimenti',
					model: 'movement'
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'serials-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'lots',
					modelClass: 'lot',
					comments: true,
					maillogs: false,
					fileuploader: true,
					redirect: {modelDef: 'serials'},
				}),
			},
			{
				path: 'movements',
				beforeEnter: ifAuthenticatedOnline,
				component: Crud,
				props: (route) => ({
					modelDef: 'movements',
					actionIcon: 'local_offer',
					title: 'Movimenti',
					subFilters: {lots: parseInt(route.params.id)},
					speedDialOptions: {'add': false, 'delete': false},
					actionPosition: 'fixed'
				}),
			},
		]
	},
	{ 
		path: '/products/pricelists/create',
		name: 'pricelists-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'pricelists',
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/products/pricelists/:id/edit',
		name: 'pricelists-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: PricelistEdit,
		props: (route) => ({
			modelDef: 'pricelists',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/products/pricelists/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/products/pricelists/' + parseInt(route.params.id) + '/',
					text: 'Listino',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'pricelists-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Pricelist,
				meta: {
					title: 'Listino'
				},
				props: (route) => ({
					id:  parseInt(route.params.id),
				}),
			},
		],
	},

	{ 
		path: '/products/warehouses/create',
		name: 'warehouses-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'warehouses',
			redirect: route.params.redirect,
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
		}),
	},
	{ 
		path: '/products/warehouses/:id/edit',
		name: 'warehouses-edit', 
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'warehouses',
			redirect: route.params.redirect,
			id:  parseInt(route.params.id)
		}),
	},
	{ 
		path: '/products/warehouses/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/products/warehouses/' + parseInt(route.params.id) + '/',
					text: 'Magazzino',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'warehouses-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'magazzino'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'warehouses',
					modelClass: 'warehouses',
					activities: true,
					fileuploader: true,
				}), 
			},
		]
	},
	{
		path: '/settingsproducts/',
		name: 'settingsproducts',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsproducts/',
					text: 'Prodotti',
				},
				{
					to: '/settingsproducts/lots',
					text: 'Lotti',
				},
				{
					to: '/settingsproducts/attributes',
					text: 'Attributi',
				},
				{
					to: '/settingsproducts/pricelists',
					text: 'Listini Anagrafici',
				},
				{
					to: '/settingsproducts/movements',
					text: 'Movimenti',
				},
				{
					to: '/settingsproducts/warehouses',
					text: 'Magazzini',
				},
				// {
				// 	to: '/settingsproducts/stocks',
				// 	text: 'Giacenze',
				// },
			]
		},
		children: [
			{
				path: '/settingsproducts/',
				beforeEnter: ifAuthenticatedOnline,
				component: ProductsSettings,
			},
			{
				path: '/settingsproducts/lots',
				beforeEnter: ifAuthenticatedOnline,
				component: LotsSettings,
			},
			{
				path: '/settingsproducts/attributes',
				beforeEnter: ifAuthenticatedOnline,
				component: AttributesSettings,
			},
			{
				path: '/settingsproducts/pricelists',
				beforeEnter: ifAuthenticatedOnline,
				component: PricelistsSettings,
			},
			{
				path: '/settingsproducts/movements',
				beforeEnter: ifAuthenticatedOnline,
				component: MovementsSettings,
			},
			{
				path: '/settingsproducts/warehouses',
				beforeEnter: ifAuthenticatedOnline,
				component: WarehousesSettings,
			},
		],
	},

]